module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "tftable",
    attrs: {
      "id": "tfhover",
      "border": "1"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('tr', [_c('td', [_vm._v("（一）认证相符的增值税专用发票")]), _vm._v(" "), _c('td', [_vm._v("1=2+3")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_1),
      expression: "fs_1"
    }],
    domProps: {
      "value": (_vm.fs_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_1),
      expression: "je_1"
    }],
    domProps: {
      "value": (_vm.je_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_1),
      expression: "se_1"
    }],
    domProps: {
      "value": (_vm.se_1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_1 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("其中：本期认证相符且本期申报抵扣")]), _vm._v(" "), _c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_2),
      expression: "fs_2"
    }],
    domProps: {
      "value": (_vm.fs_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_2),
      expression: "je_2"
    }],
    domProps: {
      "value": (_vm.je_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_2),
      expression: "se_2"
    }],
    domProps: {
      "value": (_vm.se_2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_2 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("前期认证相符且本期申报抵扣")]), _vm._v(" "), _c('td', [_vm._v("3")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_3),
      expression: "fs_3"
    }],
    domProps: {
      "value": (_vm.fs_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_3),
      expression: "je_3"
    }],
    domProps: {
      "value": (_vm.je_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_3 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_3),
      expression: "se_3"
    }],
    domProps: {
      "value": (_vm.se_3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_3 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("（二）其他扣税凭证")]), _vm._v(" "), _c('td', [_vm._v("4=5+6+7+8a+8b")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_4),
      expression: "fs_4"
    }],
    domProps: {
      "value": (_vm.fs_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_4),
      expression: "je_4"
    }],
    domProps: {
      "value": (_vm.je_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_4 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_4),
      expression: "se_4"
    }],
    domProps: {
      "value": (_vm.se_4)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_4 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("其中：海关进口增值税专用缴款书")]), _vm._v(" "), _c('td', [_vm._v("5")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_5),
      expression: "fs_5"
    }],
    domProps: {
      "value": (_vm.fs_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_5 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_5),
      expression: "je_5"
    }],
    domProps: {
      "value": (_vm.je_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_5 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_5),
      expression: "se_5"
    }],
    domProps: {
      "value": (_vm.se_5)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_5 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("农产品收购发票或者销售发票")]), _vm._v(" "), _c('td', [_vm._v("6")]), _vm._v(" "), _c('td', [_vm._v("不填写")]), _vm._v(" "), _c('td', [_vm._v("不填写")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_6),
      expression: "se_6"
    }],
    domProps: {
      "value": (_vm.se_6)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_6 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("代扣代缴税收缴款凭证")]), _vm._v(" "), _c('td', [_vm._v("7")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_7),
      expression: "fs_7"
    }],
    domProps: {
      "value": (_vm.fs_7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_7 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_7),
      expression: "je_7"
    }],
    domProps: {
      "value": (_vm.je_7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_7 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_7),
      expression: "se_7"
    }],
    domProps: {
      "value": (_vm.se_7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_7 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("加计扣除农产品进项税额")]), _vm._v(" "), _c('td', [_vm._v("8a")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_8a),
      expression: "fs_8a"
    }],
    domProps: {
      "value": (_vm.fs_8a)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_8a = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_8a),
      expression: "je_8a"
    }],
    domProps: {
      "value": (_vm.je_8a)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_8a = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_8a),
      expression: "se_8a"
    }],
    domProps: {
      "value": (_vm.se_8a)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_8a = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("其他")]), _vm._v(" "), _c('td', [_vm._v("8b")]), _vm._v(" "), _c('td', [_vm._v("不填写")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_8b),
      expression: "je_8b"
    }],
    domProps: {
      "value": (_vm.je_8b)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_8b = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_8b),
      expression: "se_8b"
    }],
    attrs: {
      "title": "/2、通行费、旅客运输服务台账可抵扣进项税额填入该栏"
    },
    domProps: {
      "value": (_vm.se_8b)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_8b = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("（三）本期用于购建不动产的扣税凭证")]), _vm._v(" "), _c('td', [_vm._v("9")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_9),
      expression: "fs_9"
    }],
    domProps: {
      "value": (_vm.fs_9)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_9 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_9),
      expression: "je_9"
    }],
    domProps: {
      "value": (_vm.je_9)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_9 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_9),
      expression: "se_9"
    }],
    domProps: {
      "value": (_vm.se_9)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_9 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("（四）本期用于抵扣的旅客运输服务扣税凭证")]), _vm._v(" "), _c('td', [_vm._v("10")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_10),
      expression: "fs_10"
    }],
    domProps: {
      "value": (_vm.fs_10)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_10 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_10),
      expression: "je_10"
    }],
    domProps: {
      "value": (_vm.je_10)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_10 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_10),
      expression: "se_10"
    }],
    domProps: {
      "value": (_vm.se_10)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_10 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("（五）外贸企业进项税额抵扣证明")]), _vm._v(" "), _c('td', [_vm._v("11")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_11),
      expression: "fs_11"
    }],
    domProps: {
      "value": (_vm.fs_11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_11 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_11),
      expression: "je_11"
    }],
    domProps: {
      "value": (_vm.je_11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_11 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_11),
      expression: "se_11"
    }],
    domProps: {
      "value": (_vm.se_11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_11 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("当期申报抵扣进项税额合计")]), _vm._v(" "), _c('td', [_vm._v("12")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_12),
      expression: "fs_12"
    }],
    domProps: {
      "value": (_vm.fs_12)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_12 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_12),
      expression: "je_12"
    }],
    domProps: {
      "value": (_vm.je_12)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_12 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_12),
      expression: "se_12"
    }],
    domProps: {
      "value": (_vm.se_12)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_12 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('tr', [_c('td', [_vm._v("本期进项税额转出额")]), _vm._v(" "), _c('td', [_vm._v("13=14至23之和")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_13),
      expression: "fs_13"
    }],
    domProps: {
      "value": (_vm.fs_13)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_13 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_13),
      expression: "je_13"
    }],
    domProps: {
      "value": (_vm.je_13)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_13 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_13),
      expression: "se_13"
    }],
    domProps: {
      "value": (_vm.se_13)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_13 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("其中：免税项目用")]), _vm._v(" "), _c('td', [_vm._v("14")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_14),
      expression: "fs_14"
    }],
    domProps: {
      "value": (_vm.fs_14)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_14 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_14),
      expression: "je_14"
    }],
    domProps: {
      "value": (_vm.je_14)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_14 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_14),
      expression: "se_14"
    }],
    domProps: {
      "value": (_vm.se_14)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_14 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("集体福利、个人消费")]), _vm._v(" "), _c('td', [_vm._v("15")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_15),
      expression: "fs_15"
    }],
    domProps: {
      "value": (_vm.fs_15)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_15 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_15),
      expression: "je_15"
    }],
    domProps: {
      "value": (_vm.je_15)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_15 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_15),
      expression: "se_15"
    }],
    domProps: {
      "value": (_vm.se_15)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_15 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("非正常损失")]), _vm._v(" "), _c('td', [_vm._v("16")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_16),
      expression: "fs_16"
    }],
    domProps: {
      "value": (_vm.fs_16)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_16 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_16),
      expression: "je_16"
    }],
    domProps: {
      "value": (_vm.je_16)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_16 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_16),
      expression: "se_16"
    }],
    domProps: {
      "value": (_vm.se_16)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_16 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("简易计税方法征税项目用")]), _vm._v(" "), _c('td', [_vm._v("17")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_17),
      expression: "fs_17"
    }],
    domProps: {
      "value": (_vm.fs_17)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_17 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_17),
      expression: "je_17"
    }],
    domProps: {
      "value": (_vm.je_17)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_17 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_17),
      expression: "se_17"
    }],
    domProps: {
      "value": (_vm.se_17)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_17 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("免抵退税办法不得抵扣的进项税额")]), _vm._v(" "), _c('td', [_vm._v("18")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_18),
      expression: "fs_18"
    }],
    domProps: {
      "value": (_vm.fs_18)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_18 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_18),
      expression: "je_18"
    }],
    domProps: {
      "value": (_vm.je_18)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_18 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_18),
      expression: "se_18"
    }],
    domProps: {
      "value": (_vm.se_18)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_18 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("纳税检查调减进项税额")]), _vm._v(" "), _c('td', [_vm._v("19")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_19),
      expression: "fs_19"
    }],
    domProps: {
      "value": (_vm.fs_19)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_19 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_19),
      expression: "je_19"
    }],
    domProps: {
      "value": (_vm.je_19)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_19 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_19),
      expression: "se_19"
    }],
    domProps: {
      "value": (_vm.se_19)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_19 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("红字专用发票信息表注明的进项税额")]), _vm._v(" "), _c('td', [_vm._v("20")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_20),
      expression: "fs_20"
    }],
    domProps: {
      "value": (_vm.fs_20)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_20 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_20),
      expression: "je_20"
    }],
    domProps: {
      "value": (_vm.je_20)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_20 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_20),
      expression: "se_20"
    }],
    domProps: {
      "value": (_vm.se_20)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_20 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("上期留抵税额抵减欠税")]), _vm._v(" "), _c('td', [_vm._v("21")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_21),
      expression: "fs_21"
    }],
    domProps: {
      "value": (_vm.fs_21)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_21 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_21),
      expression: "je_21"
    }],
    domProps: {
      "value": (_vm.je_21)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_21 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_21),
      expression: "se_21"
    }],
    domProps: {
      "value": (_vm.se_21)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_21 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("上期留抵税额退税")]), _vm._v(" "), _c('td', [_vm._v("22")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_22),
      expression: "fs_22"
    }],
    domProps: {
      "value": (_vm.fs_22)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_22 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_22),
      expression: "je_22"
    }],
    domProps: {
      "value": (_vm.je_22)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_22 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_22),
      expression: "se_22"
    }],
    domProps: {
      "value": (_vm.se_22)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_22 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("其他应作进项税额转出的情形")]), _vm._v(" "), _c('td', [_vm._v("23")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_23),
      expression: "fs_23"
    }],
    domProps: {
      "value": (_vm.fs_23)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_23 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_23),
      expression: "je_23"
    }],
    domProps: {
      "value": (_vm.je_23)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_23 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_23),
      expression: "se_23"
    }],
    domProps: {
      "value": (_vm.se_23)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_23 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('tr', [_c('td', [_vm._v("（一）认证相符的增值税专用发票")]), _vm._v(" "), _c('td', [_vm._v("24")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_24),
      expression: "fs_24"
    }],
    domProps: {
      "value": (_vm.fs_24)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_24 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_24),
      expression: "je_24"
    }],
    domProps: {
      "value": (_vm.je_24)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_24 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_24),
      expression: "se_24"
    }],
    domProps: {
      "value": (_vm.se_24)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_24 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("期初已认证相符但未申报抵扣")]), _vm._v(" "), _c('td', [_vm._v("25")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_25),
      expression: "fs_25"
    }],
    domProps: {
      "value": (_vm.fs_25)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_25 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_25),
      expression: "je_25"
    }],
    domProps: {
      "value": (_vm.je_25)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_25 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_25),
      expression: "se_25"
    }],
    domProps: {
      "value": (_vm.se_25)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_25 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("本期认证相符且本期未申报抵扣")]), _vm._v(" "), _c('td', [_vm._v("26")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_26),
      expression: "fs_26"
    }],
    domProps: {
      "value": (_vm.fs_26)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_26 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_26),
      expression: "je_26"
    }],
    domProps: {
      "value": (_vm.je_26)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_26 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_26),
      expression: "se_26"
    }],
    domProps: {
      "value": (_vm.se_26)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_26 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("期末已认证相符但未申报抵扣")]), _vm._v(" "), _c('td', [_vm._v("27")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_27),
      expression: "fs_27"
    }],
    domProps: {
      "value": (_vm.fs_27)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_27 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_27),
      expression: "je_27"
    }],
    domProps: {
      "value": (_vm.je_27)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_27 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_27),
      expression: "se_27"
    }],
    domProps: {
      "value": (_vm.se_27)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_27 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("其中：按照税法规定不允许抵扣")]), _vm._v(" "), _c('td', [_vm._v("28")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_28),
      expression: "fs_28"
    }],
    domProps: {
      "value": (_vm.fs_28)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_28 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_28),
      expression: "je_28"
    }],
    domProps: {
      "value": (_vm.je_28)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_28 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_28),
      expression: "se_28"
    }],
    domProps: {
      "value": (_vm.se_28)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_28 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("（二）其他扣税凭证")]), _vm._v(" "), _c('td', [_vm._v("29=30至33之和")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_29),
      expression: "fs_29"
    }],
    domProps: {
      "value": (_vm.fs_29)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_29 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_29),
      expression: "je_29"
    }],
    domProps: {
      "value": (_vm.je_29)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_29 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_29),
      expression: "se_29"
    }],
    domProps: {
      "value": (_vm.se_29)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_29 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("其中：海关进口增值税专用缴款书")]), _vm._v(" "), _c('td', [_vm._v("30")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_30),
      expression: "fs_30"
    }],
    domProps: {
      "value": (_vm.fs_30)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_30 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_30),
      expression: "je_30"
    }],
    domProps: {
      "value": (_vm.je_30)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_30 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_30),
      expression: "se_30"
    }],
    domProps: {
      "value": (_vm.se_30)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_30 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("农产品收购发票或者销售发票")]), _vm._v(" "), _c('td', [_vm._v("31")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_31),
      expression: "fs_31"
    }],
    domProps: {
      "value": (_vm.fs_31)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_31 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_31),
      expression: "je_31"
    }],
    domProps: {
      "value": (_vm.je_31)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_31 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_31),
      expression: "se_31"
    }],
    domProps: {
      "value": (_vm.se_31)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_31 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("代扣代缴税收缴款凭证")]), _vm._v(" "), _c('td', [_vm._v("32")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_32),
      expression: "fs_32"
    }],
    domProps: {
      "value": (_vm.fs_32)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_32 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_32),
      expression: "je_32"
    }],
    domProps: {
      "value": (_vm.je_32)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_32 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_32),
      expression: "se_32"
    }],
    domProps: {
      "value": (_vm.se_32)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_32 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("其他")]), _vm._v(" "), _c('td', [_vm._v("33")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_33),
      expression: "fs_33"
    }],
    domProps: {
      "value": (_vm.fs_33)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_33 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_33),
      expression: "je_33"
    }],
    domProps: {
      "value": (_vm.je_33)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_33 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_33),
      expression: "se_33"
    }],
    domProps: {
      "value": (_vm.se_33)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_33 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("34")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_34),
      expression: "fs_34"
    }],
    domProps: {
      "value": (_vm.fs_34)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_34 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_34),
      expression: "je_34"
    }],
    domProps: {
      "value": (_vm.je_34)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_34 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_34),
      expression: "se_34"
    }],
    domProps: {
      "value": (_vm.se_34)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_34 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('tr', [_c('td', [_vm._v("本期认证相符的增值税专用发票")]), _vm._v(" "), _c('td', [_vm._v("35")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_35),
      expression: "fs_35"
    }],
    domProps: {
      "value": (_vm.fs_35)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_35 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_35),
      expression: "je_35"
    }],
    domProps: {
      "value": (_vm.je_35)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_35 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_35),
      expression: "se_35"
    }],
    domProps: {
      "value": (_vm.se_35)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_35 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("代扣代缴税额")]), _vm._v(" "), _c('td', [_vm._v("36")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fs_36),
      expression: "fs_36"
    }],
    domProps: {
      "value": (_vm.fs_36)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fs_36 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.je_36),
      expression: "je_36"
    }],
    domProps: {
      "value": (_vm.je_36)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.je_36 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.se_36),
      expression: "se_36"
    }],
    domProps: {
      "value": (_vm.se_36)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.se_36 = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("增值税纳税申报表附列资料（二）")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticStyle: {
      "text-align": "center",
      "font-size": "12px"
    },
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("（本期进项税额明细）")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("税款所属时间： 年 月 日 至 年 月 日")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("纳税人名称：（公章）")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v("金额单位：元至角分")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("一、申报抵扣的进项税额")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("项目")]), _vm._v(" "), _c('td', [_vm._v("栏次")]), _vm._v(" "), _c('td', [_vm._v("份数")]), _vm._v(" "), _c('td', [_vm._v("金额")]), _vm._v(" "), _c('td', [_vm._v("税额")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("二、进项税额转出额")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("项目")]), _vm._v(" "), _c('td', [_vm._v("栏次")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("税额")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("三、待抵扣进项税额")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("项目")]), _vm._v(" "), _c('td', [_vm._v("栏次")]), _vm._v(" "), _c('td', [_vm._v("份数")]), _vm._v(" "), _c('td', [_vm._v("金额")]), _vm._v(" "), _c('td', [_vm._v("税额")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("四、其他")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("项目")]), _vm._v(" "), _c('td', [_vm._v("栏次")]), _vm._v(" "), _c('td', [_vm._v("份数")]), _vm._v(" "), _c('td', [_vm._v("金额")]), _vm._v(" "), _c('td', [_vm._v("税额")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24844ad0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nssb/table2.vue
// module id = 712
// module chunks = 1